exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, "ul[data-v-0607fa90]{@util reset-list}li[data-v-0607fa90]{cursor:pointer;display:inline}a[data-v-0607fa90]{font-size:12px;font-family:Arial,sans-serif;border-radius:15px;padding:3px 8px;transition:.3s;border:1px solid transparent}.active a[data-v-0607fa90],a[data-v-0607fa90]:hover{border:1px solid var(--azure)}.active a[data-v-0607fa90]{background-color:var(--azure)}.selector[data-v-0607fa90]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0607fa90","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/OrderBySelector.vue
// module id = 488
// module chunks = 0